import { Auth } from 'aws-amplify';

// AWS Configuration
const awsConfig = {
  // Cognito
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_sH3H05RRs',
    userPoolWebClientId: '1trprpkhjd4tfb1crumranhpll',
    identityPoolId: 'us-east-1:4de0b899-1a86-4e45-b3c9-42bc88977c67',
    oauth: {
      domain: 'namapages-470063692372.auth.us-east-1.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'profile'],
      redirectSignIn: window.location.origin,
      redirectSignOut: window.location.origin,
      responseType: 'code'
    }
  },
  // API Gateway
  API: {
    endpoints: [
      {
        name: 'NamapagesAPI',
        //endpoint: 'https://2ex3pv49r7.execute-api.us-east-1.amazonaws.com/prod/',
        endpoint: 'https://api.namapages.com/',
        region: 'us-east-1'
      },
      {
        name: 'PlaylistsAPI',
        //endpoint: 'https://t53ojoiepk.execute-api.us-east-1.amazonaws.com/prod/',
        endpoint: 'https://api.namapages.com/',
        region: 'us-east-1'
      }
    ]
  }
};

export default awsConfig;